/**
 * Android (Capacitor) platform adapter — stub.
 *
 * Real implementation will use Capacitor plugins:
 *   - `@capacitor/preferences` for storage
 *   - `@capacitor/haptics` for vibrate
 *   - `@capacitor/share` for share
 *   - `@capacitor/app` for back-button (and `addListener('backButton', …)`)
 *   - `@capacitor/status-bar` and SafeAreaInsets for layout
 *
 * Reference: https://capacitorjs.com/docs/
 *
 * Detection: `window.Capacitor` is injected by the native bridge when running
 * inside the Capacitor wrapper.
 */
import type { PlatformAdapter } from './adapter.js';

export function createAndroidAdapter(): PlatformAdapter {
  throw new Error(
    'createAndroidAdapter is not yet implemented. ' +
      'Add Capacitor plugins and wire them here when preparing the Play Market build. ' +
      'See ARCHITECTURE.md → PlatformAdapter section.',
  );
}

export function isCapacitorRuntime(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return cap?.isNativePlatform?.() === true;
}
